import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { first, switchMap, tap, toArray } from 'rxjs/operators';

import { ApiProduct } from 'idt-ecommerce-api/_api/api-catalog/api-products/api-products.models';
import { Product, ProductWithCategory } from 'idt-ecommerce-api/catalog/products/products.models';
import { ProductsModelsTransformer } from 'idt-ecommerce-api/catalog/products/products.models.transformer';
import { ProductsService } from 'idt-ecommerce-api/catalog/products/products.service';
import { EcommerceContext } from 'idt-ecommerce-api/context/context.models';
import { ContextService } from 'idt-ecommerce-api/context/context.service';
import { RenderStorageService } from 'render/render-storage/render-storage.service';

import { RenderStoreLocationProducts } from './render-storage-products.models';


@Injectable()
export class RenderStorageProductsService extends RenderStorageService {

  constructor(
    private readonly contextService: ContextService,
    private readonly productsService: ProductsService
  ) {
    super();
  }

  public getLastViewed(): Observable<ProductWithCategory[]> {
    return this.contextService.getContext$().pipe(
      first(),
      switchMap((context: EcommerceContext) => {
        const rawData = this.getItem(RenderStoreLocationProducts.LAST_VIEWED);
        const parsedData = rawData && JSON.parse(rawData) as { products: ProductInStorage[] };
        if (parsedData) {
          const items: ProductInStorage[] = parsedData.products ?? [];
          return items.map((item) => {
            const apiProductTransformed: Product = ProductsModelsTransformer.productFromApi(item.product, context);
            return {
              ...apiProductTransformed,
              categoryId: item.categoryId?.toString() ?? '0'
            };
          });
        }
        return [];
      }),
      toArray(),
      tap((products) => {
        this.productsService.addProductsToStore(products);
      })
    );
  }

}

interface ProductInStorage {
  product: ApiProduct;
  categoryId: number;
}
